import { render, staticRenderFns } from "./LinkBoxes.vue?vue&type=template&id=21834e3a&"
import script from "./LinkBoxes.vue?vue&type=script&lang=js&"
export * from "./LinkBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports